import BaseTable from 'components/Tables/BaseTable';
import { sortBy } from 'lodash';
import filterMergeProductDescriptors
  from "pages/ScenarioExposure/Product/ScenariosManagement/filterMergeProductDescriptors";
import ProductListDetailPanel from 'pages/ScenarioExposure/Product/ScenariosManagement/ProducListDetailPanel';
import ProductListByPCDetailPanel from "pages/ScenarioExposure/Product/ScenariosManagement/ProductListByPCDetailPanel";
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData } from 'selectors/generic';
import theme from 'source/theme';
import { ERC, PC, PROC } from "utils/constants/descriptorTypes";
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioExposure/product/productPcSuScenarioDescriptorExposure';

const Component = props => {
  const {
    descriptorId, descriptorsById, descriptorsData, descriptorFilter,
    productsById, productScenarioDescriptors, scenariosById, TABLE_HEIGHT
  } = props;

  const { setDescriptorId } = props;
  const tableRef = useRef();

  const mergedProductDescriptors = filterMergeProductDescriptors(descriptorFilter, productsById, descriptorsById, descriptorsData, productScenarioDescriptors, scenariosById);
  const delayedPCmergedProductDescriptors = () => filterMergeProductDescriptors(PC, productsById, descriptorsById, descriptorsData, productScenarioDescriptors, scenariosById);

  const rows = sortBy(mergedProductDescriptors, ['id']);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        title={'DESCRITORES DE PRODUTO'}
        columns={columns}
        data={rows}
        paging={false}
        onRowClick={() => null}
        onRowDoubleClick={setDescriptorId ? rowData => setDescriptorId(rowData.id) : null}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          rowStyle: setDescriptorId ? rowData => ({
              backgroundColor: (rowData.id === descriptorId) ?
                theme.palette.primary.light :
                theme.palette.background.veryLight
            }) :
            ({ backgroundColor: theme.palette.background.veryLight })
        }}
        detailPanel={[
          () => ({
            icon: tableIcons.Products,
            tooltip: 'Produtos',
            render: descriptorFilter === PROC || descriptorFilter === ERC ?
              rowData => <ProductListByPCDetailPanel row={rowData} pcListOfProduct={delayedPCmergedProductDescriptors()}/> :
              rowData => <ProductListDetailPanel row={rowData}/>
          })
        ]}
      />
    </React.Fragment>
  );
};


const makeMapStateToProps = () => {
  const immutableDescriptorsData = getImmutableStoreData('descriptors');
  const mapStateToProps = (state, props) => ({
    descriptorsData: immutableDescriptorsData(state),
    descriptorsById: state.descriptors.dataById,
    productsById: state.products.dataById,
    scenariosById: state.scenarios.dataById
  });
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(Component);
